import React from 'react';

export const Preloader = () => <div className='store__preloader' />;
